var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrfLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 304.7 38",
    style: {
      enableBackground: "new 0 0 304.7 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#FFD200;}\t.st1{fill:#FFFFFF;}\t.st2{fill:#00437C;}\t.st3{fill:none;stroke:#00437C;stroke-width:1.3776;stroke-miterlimit:10;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 2.1,
    className: "st0",
    width: 98,
    height: 33.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.4,
    y: 2.1,
    className: "st1",
    width: 107.1,
    height: 33.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 2.1,
    className: "st2",
    width: 94.9,
    height: 33.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    className: "st3",
    width: 299.9,
    height: 33.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.5,8h14.7v4.4h-9.8v4.4h9.1v4.4h-9.1v8.5h-4.8V8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.2,8h4l9.5,21.8h-5.4l-1.9-4.6h-8.5l-1.8,4.6h-5.3L242.2,8z M244.1,14.4l-2.7,6.8h5.3L244.1,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.4,13.4c-0.4-0.5-0.9-0.9-1.6-1.1c-0.7-0.2-1.3-0.4-1.9-0.4c-0.3,0-0.7,0-1.1,0.1c-0.4,0.1-0.7,0.2-1,0.4   c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,1c0,0.7,0.2,1.2,0.7,1.5c0.5,0.3,1.1,0.6,1.9,0.9c0.8,0.2,1.6,0.5,2.4,0.7   c0.9,0.2,1.7,0.6,2.4,1c0.8,0.5,1.4,1.1,1.9,1.8c0.5,0.8,0.7,1.8,0.7,3.1c0,1.2-0.2,2.3-0.7,3.2c-0.5,0.9-1.1,1.7-1.8,2.3   c-0.8,0.6-1.7,1-2.7,1.3s-2.1,0.4-3.2,0.4c-1.4,0-2.7-0.2-3.9-0.6c-1.2-0.4-2.3-1.1-3.4-2.1l3.4-3.8c0.5,0.7,1.1,1.2,1.9,1.5   c0.8,0.4,1.5,0.5,2.3,0.5c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.8-0.2,1.1-0.4c0.3-0.2,0.6-0.4,0.8-0.7s0.3-0.6,0.3-1   c0-0.7-0.3-1.2-0.8-1.6c-0.5-0.4-1.1-0.7-1.9-1c-0.8-0.3-1.6-0.5-2.5-0.8c-0.9-0.3-1.7-0.6-2.5-1.1c-0.8-0.5-1.4-1-1.9-1.8   c-0.5-0.7-0.8-1.7-0.8-2.9c0-1.2,0.2-2.2,0.7-3.1c0.5-0.9,1.1-1.6,1.9-2.2c0.8-0.6,1.7-1,2.7-1.3c1-0.3,2-0.4,3.1-0.4   c1.2,0,2.4,0.2,3.6,0.5c1.2,0.3,2.2,0.9,3.1,1.8L268.4,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.2,12.3H273V8h17.3v4.3H284v17.6h-4.8V12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.4,27.2c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.7,0.6-0.9c0.3-0.3,0.6-0.5,0.9-0.6c0.3-0.1,0.7-0.2,1.1-0.2   c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.7,0.3,0.9,0.6c0.3,0.3,0.5,0.6,0.6,0.9c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1   c-0.1,0.3-0.3,0.7-0.6,0.9c-0.3,0.3-0.6,0.5-0.9,0.6c-0.3,0.1-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.4-0.1-0.7-0.3-0.9-0.6   c-0.3-0.3-0.5-0.6-0.6-0.9C288.5,28,288.4,27.6,288.4,27.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.2,8.4h8.5c1.1,0,2.2,0.1,3.2,0.3s1.9,0.6,2.6,1.1c0.8,0.5,1.3,1.2,1.8,2c0.4,0.9,0.7,1.9,0.7,3.2   c0,1.5-0.4,2.9-1.2,3.9c-0.8,1.1-2,1.8-3.5,2.1l5.6,9.2h-5.8l-4.6-8.7H113v8.7h-4.8V8.4z M113,17.4h2.8c0.4,0,0.9,0,1.4,0   c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.4,1-0.7c0.3-0.3,0.4-0.8,0.4-1.4c0-0.6-0.1-1-0.3-1.3c-0.2-0.3-0.5-0.6-0.9-0.8   c-0.3-0.2-0.8-0.3-1.2-0.4c-0.5-0.1-0.9-0.1-1.3-0.1H113V17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.8,8.4h4.8v21.8h-4.8V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.5,28.7c-1.4,0.7-2.9,1.3-4.4,1.6c-1.5,0.3-3.1,0.5-4.7,0.5c-1.7,0-3.3-0.3-4.7-0.8   c-1.4-0.5-2.7-1.3-3.7-2.3c-1-1-1.9-2.2-2.5-3.6c-0.6-1.4-0.9-3-0.9-4.8c0-1.7,0.3-3.3,0.9-4.8c0.6-1.4,1.4-2.6,2.5-3.6   c1-1,2.3-1.8,3.7-2.3c1.4-0.5,3-0.8,4.7-0.8c1.7,0,3.4,0.2,4.8,0.6c1.5,0.4,2.8,1.1,3.9,2.2l-3.4,3.7c-0.7-0.7-1.4-1.2-2.2-1.5   c-0.8-0.3-1.9-0.5-3.1-0.5c-1,0-2,0.2-2.8,0.5c-0.8,0.4-1.5,0.8-2.1,1.5c-0.6,0.6-1.1,1.4-1.4,2.2c-0.3,0.9-0.5,1.8-0.5,2.8   c0,1,0.2,2,0.5,2.8c0.3,0.9,0.8,1.6,1.4,2.2c0.6,0.6,1.3,1.1,2.1,1.5c0.8,0.4,1.8,0.5,2.8,0.5c1,0,2-0.1,2.7-0.4   c0.8-0.2,1.4-0.5,1.8-0.7v-3.5h-3.9v-4.4h8.5V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.4,8.4h4.8v8.1h9.3V8.4h4.8v21.8h-4.8v-9.4h-9.3v9.4h-4.8V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.7,12.6h-6.2V8.4h17.3v4.3h-6.2v17.6h-4.8V12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197,27.5c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.7,0.6-0.9c0.3-0.3,0.6-0.5,0.9-0.6c0.3-0.1,0.7-0.2,1.1-0.2   c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.7,0.3,0.9,0.6c0.3,0.3,0.5,0.6,0.6,0.9c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1   c-0.1,0.3-0.3,0.7-0.6,0.9c-0.3,0.3-0.6,0.5-0.9,0.6c-0.3,0.1-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.7-0.3-0.9-0.6   c-0.3-0.3-0.5-0.6-0.6-0.9C197,28.3,197,27.9,197,27.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.5,13.7c-0.4-0.5-0.9-0.9-1.6-1.1c-0.7-0.2-1.3-0.4-1.9-0.4c-0.3,0-0.7,0-1.1,0.1c-0.4,0.1-0.7,0.2-1,0.4   c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,1c0,0.7,0.2,1.2,0.7,1.5c0.5,0.3,1.1,0.6,1.9,0.9c0.8,0.2,1.6,0.5,2.4,0.7   c0.9,0.2,1.7,0.6,2.4,1c0.8,0.5,1.4,1.1,1.9,1.8c0.5,0.8,0.7,1.8,0.7,3.1c0,1.2-0.2,2.3-0.7,3.2c-0.5,0.9-1.1,1.7-1.8,2.3   c-0.8,0.6-1.7,1-2.7,1.3c-1,0.3-2.1,0.4-3.2,0.4c-1.4,0-2.7-0.2-3.9-0.6c-1.2-0.4-2.3-1.1-3.4-2.1l3.4-3.8   c0.5,0.7,1.1,1.2,1.9,1.5c0.8,0.4,1.5,0.5,2.3,0.5c0.4,0,0.8,0,1.2-0.1c0.4-0.1,0.8-0.2,1.1-0.4c0.3-0.2,0.6-0.4,0.8-0.7   c0.2-0.3,0.3-0.6,0.3-1c0-0.7-0.3-1.2-0.8-1.6c-0.5-0.4-1.1-0.7-1.9-1c-0.8-0.3-1.6-0.5-2.5-0.8c-0.9-0.3-1.7-0.6-2.5-1.1   c-0.8-0.5-1.4-1-1.9-1.8c-0.5-0.7-0.8-1.7-0.8-2.9c0-1.2,0.2-2.2,0.7-3.1c0.5-0.9,1.1-1.6,1.9-2.2C14.1,9,15,8.5,16,8.2   c1-0.3,2-0.4,3.1-0.4c1.2,0,2.4,0.2,3.6,0.5c1.2,0.3,2.2,0.9,3.1,1.8L22.5,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.5,8.4h4L49,30.2h-5.4l-1.9-4.6h-8.5l-1.8,4.6h-5.3L35.5,8.4z M37.4,14.7l-2.7,6.8h5.3L37.4,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.1,8.4h14.7v4.4h-9.8v4.4H65v4.4h-9.1v8.5h-4.8V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,8.4h14.8v4.4h-10v4.1h9.5v4.4h-9.5v4.4h10.6v4.4H69.1V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.5,27.5c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.7,0.6-0.9c0.3-0.3,0.6-0.5,0.9-0.6c0.3-0.1,0.7-0.2,1.1-0.2   c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.7,0.3,0.9,0.6c0.3,0.3,0.5,0.6,0.6,0.9c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1   c-0.1,0.3-0.3,0.7-0.6,0.9c-0.3,0.3-0.6,0.5-0.9,0.6c-0.3,0.1-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.7-0.3-0.9-0.6   c-0.3-0.3-0.5-0.6-0.6-0.9C87.6,28.3,87.5,27.9,87.5,27.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrfLogo);
export default __webpack_public_path__ + "static/media/SRF_Logo.963226f8675b9543eb66374f61b3ba05.svg";
export { ForwardRef as ReactComponent };